import Cookies from 'js-cookie';
import HttpMethod from '../../app/enums/HttpMethod';
import { localizedRoute } from '../../app/support/helpers';
import { isValidEmail, initIntlInput, allValidations } from './functions';


export default function() {

    var validation = allValidations();
    var intlTelInstance;
    var _doctor_id;
    var _client_id;
    var _action;
    var $modal;


    $('.reportAbuse').on('click', function(event) {
        event.preventDefault();

        var $element = $(this);

        _doctor_id = parseInt($element.data('doctorId'));
        _client_id = parseInt($element.data('clientId'));
        _action    = $element.data('action');

        $modal = $('#reportModal');

        // console.log('intlTelInstance : ', intlTelInstance);
        intlTelInstance = intlTelInstance ? intlTelInstance : initIntlInput($modal.find('#abuseMobile').get(0));


        initUserInfo();


        showModal();


        closeModalClickEvent();


        sendModalClickEvent();
    });


    function initUserInfo() {

        if (cookieExists()) {

            var User = extractDataFromCookie();
            // console.log('User : ', User);
            $modal.find('#abuseFirstname').val(User.firstname).hide();
            $modal.find('#abuseLastname').val(User.lastname).hide();
            $modal.find('#abuseEmail').val(User.email).hide();

            $modal.find('#abuseMobile').val(User.mobile);
            $modal.find('.intl-tel-input').hide();
        }
    }


    function cookieExists() {
        return Cookies.get('user_info');
    }


    function extractDataFromCookie() {

        return JSON.parse(Cookies.get('user_info'));
    }


    function showModal() {

        $modal.modal('show');
    }


    function closeModalClickEvent() {

        $('#cancelReportModal')
        .off('click')
        .on('click', function(event) {
            event.preventDefault();

            hideModal();
        });
    }


    function hideModal() {

        $modal.modal('hide');
    }


    function sendModalClickEvent() {

        $('#sendReportModal')
        .off('click')
        .on('click', function(event) {
            event.preventDefault();

            validateUserInfoFrom();
        });
    }


    function validateUserInfoFrom() {


        var $firstname  = $modal.find('#abuseFirstname');
        var $lastname   = $modal.find('#abuseLastname');
        var $mobile     = $modal.find('#abuseMobile');
        var $email      = $modal.find('#abuseEmail');
        var $type       = $modal.find('#abuseType');
        var $message    = $modal.find('#abuseMessage');

        var $alert      = $modal.find('.alert-errors');
        var $successAlert = $modal.find('.alert');
        var $form       = $modal.find('form');
        var $loading    = $modal.find('.loading');

        var firstname   = $.trim($firstname.val());
        var lastname    = $.trim($lastname.val());
        var mobile      = $.trim($mobile.val());
        var email       = $.trim($email.val());
        var type        = $type.val();
        var message     = $.trim($message.val());

        var user_exists = cookieExists();
        var errors      = [];

        // if there is no user cookie found
        if (! user_exists) {

            if (!firstname) {
                errors.push(validation.firstname.required);
                $firstname.addClass('input-error');
            } else {
                $firstname.removeClass('input-error');
            }

            if (!lastname) {
                errors.push(validation.lastname.required);
                $lastname.addClass('input-error');
            } else {
                $lastname.removeClass('input-error');
            }

            if (!mobile) {
                errors.push(validation.mobile.required);
                $mobile.addClass('input-error');
            } else {
                $mobile.removeClass('input-error');
            }

            if (!email) {
                errors.push(validation.email.required);
                $email.addClass('input-error');
            } else {
                $email.removeClass('input-error');
            }

            if (email) {
                if (!isValidEmail(email)) {
                    errors.push(validation.email.invalid);
                    $email.addClass('input-error');
                } else {
                    $email.removeClass('input-error');
                }
            }

            if (mobile) {
                if (!intlTelInstance.isValidNumber()) {
                    errors.push(validation.mobile.invalid);
                    $mobile.addClass('input-error');
                } else {
                    $mobile.removeClass('input-error');
                    $mobile.val(intlTelInstance.getNumber());
                }
            }
        }


        if (!message) {
            errors.push(validation.message.required);
            $message.addClass('input-error');
        } else {
            $message.removeClass('input-error');
        }


        if (errors.length) {
            $alert.html(' ');

            errors.forEach(function(element, index) {
                $alert.append('<p>' + element + '</p>');
            });

            $alert
                .prepend(
                    "<button data-dismiss='alert' class='close' type='button'>×</button>"
                )
                .show();

            $alert.show();

            $alert.off().on('click', function(event) {
                event.preventDefault();
                $(this).hide();
            });

        } else {

            $alert.hide();

            $.ajax({
                url: localizedRoute('frontend.practitioners.report_abuse', _doctor_id),
                type: HttpMethod.POST,
                dataType: 'json',
                data: {
                    firstname   : firstname,
                    lastname    : lastname,
                    mobile      : intlTelInstance.getNumber(),
                    dial_code   : intlTelInstance.getSelectedCountryData().dialCode,
                    email       : email,
                    type        : type,
                    message     : message,
                    action      : _action,
                    client_id   : !isNaN(_client_id) ? _client_id : null,
                },
                beforeSend: function() {

                    $loading.show();

                    $form.css({
                        opacity: '0.3',
                        pointerEvent: 'none'
                    });
                }
            }).done(function(data) {

                Cookies.set('user_info', JSON.stringify(data), { expires: 3650 });

                $form.hide();

                $successAlert.show();

                setTimeout(function() {

                    hideModal();
                }, 5000);

            }).always(function() {

                $loading.hide();

                $form.css({
                    opacity: '1',
                    pointerEvent: 'inherit'
                });
            });
        }
    }
}
